import { AppThunk } from '../../../../store/types';
import { TConferenceSettings } from '../../../../../common/rest/conference/conferenceRest';
import { getAudioById } from '../../../../store/models/selectors';
import { RecordingsEffects } from '../../../../effects/recordingsEffects';
import { TRecordingInfoPatch, TRestoreInfoResult } from '../../../../../common/rest/audio/audioRest';

export class ConferenceSettingsEvents {

	public static onChange(
		audioId: number,
		settings: TConferenceSettings,
	): AppThunk {
		return (
			dispatch,
			getState
		) => {
			const audio = getAudioById(getState(), audioId);
			const roomId = RecordingsEffects.getRoomIdForAudio(audio);
			if (roomId) RecordingsEffects.setConferenceSettings(roomId, settings, audioId);
		}
	}

	public static onInfoChange(
		audioId: number,
		info: TRecordingInfoPatch,
	): AppThunk {
		return () => {
			if (audioId) RecordingsEffects.saveInfo(audioId, info);
		}
	}

	public static onGenerateInfo(
		audioId: number,
		first: boolean,
	): AppThunk<Promise<boolean>> {
		return async () => {
			return !!audioId && RecordingsEffects.generateInfo(audioId, first);
		}
	}

	public static onRestoreInfo(
		audioId: number,
	): AppThunk<Promise<TRestoreInfoResult>> {
		return async () => {
			return audioId ? RecordingsEffects.restoreInfo(audioId) : 'failed';
		}
	}

}
